import { HTTP_METHODS } from "../utils/constants";
import { networkBackendRequest, networkUploadRequest } from "./networkUtils";

export function uploadFileToS3(documentType, files, prefix) {
  return Promise.all(
    files.map((file, idx) => {
      const fileExt = (/\.[^.]*$/.exec(file.name) || [""])[0];
      const filename = `${prefix}${idx + 1}${fileExt}`;
      return networkBackendRequest(
        "/files/presigned-upload-url/",
        HTTP_METHODS.GET,
        {
          file_type: documentType,
          content_type: file.type,
        }
      )
        .then((response) => response.json())
        .then((presignedPostRequest) => {
          const formData = new FormData();

          /*eslint-disable */
          const objectName = presignedPostRequest.fields["key"].replace(
            "${filename}",
            filename
          );
          Object.keys(presignedPostRequest.fields).forEach((key) => {
            formData.append(key, presignedPostRequest.fields[key]);
          });
          formData.append("file", file, filename);
          return networkUploadRequest(
            presignedPostRequest.url,
            HTTP_METHODS.POST,
            null,
            formData
          ).then(() => objectName);
        });
    })
  );
}
